<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>請假單審核</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>請假單審核</span></li>
        </ol>
      </div>
    </header>
    <div id="tabs-0" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <div class="panel-body">
              <div class="form-group">
                <label class="col-md-2 control-label">聘僱單位：</label>
                <div class="col-md-4">{{item.deptName}}</div>
                <label class="col-md-2 control-label">姓　　名：</label>
                <div class="col-md-4">{{item.studentName}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">班　　級：</label>
                <div class="col-md-4">{{item.dradeClass}}</div>
                <label class="col-md-2 control-label">學　　號：</label>
                <div class="col-md-4">{{item.studentId}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">事　　由：</label>
                <div class="col-md-10">{{item.leaveContent}}</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">請假日期：</label>
                <div class="col-md-10">{{item.leaveTime}}　　合計<span style="color:#FF0000;">　{{item.leaveTotalHours}}　</span>小時</div>
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">審核結果<span style="color:#FF0000;">*</span>：</label>
                <div class="col-md-10">
                  <select @change.prevent="isPassChange">
                    <option value="">請選擇</option>
                    <option value="1">審核通過</option>
                    <option value="0">審核不通過</option>
                  </select>　
                  <label v-show="form.isPass==false">原因：<input type="text" size="20" v-model="form.notPassReason"> ( 審核不通過才需填寫原因 )</label>
                  
                </div>
              </div>
              <table width="100%">
                <tr>
                  <td align="right"><a href="#" @click.prevent="formClear" class="btn-upload btn" style="background-color:#666; border-color:#999; color:#FFF;">重　　填</a>　</td>
                  <td align="left"><a href="#" @click.prevent="formSubmit" class="btn-upload btn" style="background-color:#337AB7; border-color:#2E6DA4; color:#FFF;">送　　出</a></td>
                </tr>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      item: {},
      form: {
        isPass: null,
        notPassReason: ""
      }
    }
  },
  computed:{
    id() {
      return this.$route.params.id;
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$http.get("/api/workstudyLeaveAudit/" + this.id).then(a => {
        this.item = a.body;
      }).catch(a => {
        this.$route.go(-1);
      });
    },
    isPassChange(e) {
      let val = $(e.target).val();
      if (val == "1") this.form.isPass = true;
      else if (val == "0") this.form.isPass = false;
      else this.form.isPass = null;
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      this.$http.post("/api/workstudyLeaveAudit/" + this.id, this.form).then(a => {
        if (a.body.status) {
          alert("儲存成功");
          this.$router.push("/leave-audit");
        } else {
          alert(a.body.msg);
          console.log(a.body.exstr);
        }
      });
    },
    formClear() {
      this.form.isPass = null;
      this.form.notPassReason = "";
    },
    checkForm() {
      if (this.form.isPass == null) {
        alert("請選擇『審核結果』");
        return false;
      }
      if (this.form.isPass == false && this.form.notPassReason == "") {
        alert("『審核不通過原因』尚未填寫");
        return false;
      }
      return true;
    }
  }
};
</script>

<style>
</style>